Ingtech.Notification.setRedirection("messaging", notification => {
  location.href = `/messaging/${notification.additionalInformations.messagingRoomId}`;
});
